import React from 'react';
import ReactDOM from 'react-dom/client'; 
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import './assets/scss/main.scss';
import App from './App';
import { preloadCompletionCelebrationImages } from '@/components/CompletionCelebration/completionCelebrationAssets';
import { initHeap } from './utils/initHeap';
import { loadNewRelicScript } from './utils/initNewRelic';

// HEAP Integration & NR Browser Integration
initHeap();
loadNewRelicScript();

preloadCompletionCelebrationImages().catch(() => {
  /* non-blocking; overlay waits on the same promise when opened */
}); 

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </BrowserRouter>
  </React.StrictMode>
);